export class ModalitaPagamentoVagliaForm {
	nome: string;
	cognome: string;
	email: string;
	pec: string;
	telefono: string;
	intestatoSudioLegale: boolean;
	domicilioRichiedenteCoincideConResidenza: boolean;
}
